export var ForwarderSecretFormatType;
(function (ForwarderSecretFormatType) {
    ForwarderSecretFormatType["TEXT"] = "text";
    ForwarderSecretFormatType["MASK"] = "mask";
    ForwarderSecretFormatType["FILE"] = "file";
})(ForwarderSecretFormatType || (ForwarderSecretFormatType = {}));
//# sourceMappingURL=ForwarderSecretFormatType.js.map